// extracted by mini-css-extract-plugin
export default {"container":"style_container__5XFl9","main":"style_main__BQ9Fy","infoCardWrapper":"style_infoCardWrapper__VQxdT"};